"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var FileCopyOutlined_1 = __importDefault(require("@material-ui/icons/FileCopyOutlined"));
var Input_1 = __importDefault(require("@material-ui/core/Input"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var utils_1 = require("../../utils");
var useStyles = utils_1.makeStyles(function (theme) { return ({
    root: {
        cursor: 'pointer !important'
    },
    input: {
        cursor: 'pointer !important'
    }
}); });
var CopyText = function (_a) {
    var text = _a.text;
    var classes = useStyles();
    var handleClick = function () { return navigator.clipboard.writeText(text); };
    return (react_1["default"].createElement(Input_1["default"], { classes: classes, fullWidth: true, startAdornment: react_1["default"].createElement(InputAdornment_1["default"], { position: "start" },
            react_1["default"].createElement(FileCopyOutlined_1["default"], null)), onClick: handleClick, value: text, disabled: true }));
};
exports["default"] = CopyText;
